<template>
  <div
    ref="banner_header_mobile"
    :class="{
      'landing_slider_header_mobile':true,
      'hide': fetched && banners.length === 0,
    }"
    style="height:180px; margin-bottom:0;"
  >
    <div
      v-for="(banner, index) in banners"
      :key="index"
      class="landing_header codered"
      style="height: 180px!important;"
    >
      <div v-if="banner.background" class="landing_header_bg codered">
        <a style="width: 100%" :href="banner.url_redirect">
          <img class="lazyload" :data-src="contentCloudFront_F('/' + banner.background)">
        </a>
      </div>
      <a
        v-else
        class="landing_header_bg codered"
        style="background-color: #171920"
        :href="banner.url_redirect"
      />
      <a class="landing_header_content mobile middle" :href="banner.url_redirect">
        <div class="lh_title">{{ banner.header }}</div>
        <div class="lh_sub_title">
          {{ banner.body }}
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { component } from '../../../../mixins/component';
import 'slick-carousel/slick/slick.min';
import jQuery from 'jquery';
import Vue from 'vue';

export default {
  mixins: [component],
  props: {
    banners: {
      type: Array,
      default() {
        return [];
      },
    },
    fetched: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    banners: function(newVal, oldVal) {
      Vue.nextTick(() => {
        this.initSlick();
      });
    },
  },
  methods: {
    initSlick() {
      jQuery(this.$refs.banner_header_mobile).slick({
        dots: true,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    },
  },
};
</script>
